import { Component, Inject, OnInit, Optional } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator } from '@app/modal/state-modal/state-modal.component';
import { BspService, BspUsergroupEdit } from '@app/services/bsp.service';

@Component({
  selector: 'tt-bsp-ug',
  templateUrl: './bsp-ug.component.html',
  styleUrls: ['./bsp-ug.component.css'],
  standalone: false,
})
export class BspUgComponent implements OnInit {
    public params?: { bsp_keyno: string; bspug_keyno: string };

    public page?: BspUsergroupEdit;

    public saving = false;

    public bspUgNameButtons = [{ id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => this.navigator?.go({ to: 'translateedit', parms: { item_id: this.page?.word_id } }) }];

    constructor(
        private bsp: BspService,
        private modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {}

    public async save(): Promise<void> {
        if (!this.page) return;

        this.saving = true;

        try {
            const response = await this.bsp.saveUsergroup(this.page);

            if (response.errorcode !== '0') {
                await this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: response.errormessage });
                return;
            }

            await this.navigator?.back();
        } finally {
            this.saving = false;
        }
    }

    public async ngOnInit(): Promise<void> {
        const params = (this.navigator?.params ?? this.params) as { bsp_keyno?: string; bspug_keyno?: string } | undefined;

        if (params?.bsp_keyno !== undefined && params.bspug_keyno !== undefined) {
            this.page = await this.bsp.getUsergroup(params.bsp_keyno, params.bspug_keyno);
        }
    }
}
